/* eslint-disable no-plusplus */
/* eslint-disable no-await-in-loop */
/*
 * @Descripttion:
 * @version:
 * @Author: lxh3@meitu.com
 * @Date: 2025-05-24 16:00:20
 * @LastEditors: lxh3@meitu.com
 * @LastEditTime: 2025-06-09 18:18:00
 */

import {
  create, StateCreator, StoreApi, UseBoundStore,
} from 'zustand';
import { immer } from 'zustand/middleware/immer';

interface ThreadInfo {
  total: number;
  done: number;
  detected?: boolean; // 检测是否完成
  canceled?: boolean; //  新增：是否直接取消
  hide?: boolean; // 隐藏Loading，AI编辑等场景上传时不需要显示进度
}
interface TUploadThreadState {
  uploadThread: Record<string, ThreadInfo>;
  cancelTaskId?: string;
}
const uploadThreadSlice: StateCreator<TUploadThreadState, [
  ['zustand/immer', never],
]> = (set, get) => ({
  uploadThread: {},
  cancelTaskId: '',
});
const useUploadThreadStore: UseBoundStore<StoreApi<TUploadThreadState>> = create<TUploadThreadState>()(immer(uploadThreadSlice));
export default useUploadThreadStore;

export function setUploadThread(threadId: string, info: Partial<ThreadInfo>) {
  if (info.hide) return;
  if (useUploadThreadStore.getState().cancelTaskId && (useUploadThreadStore.getState().cancelTaskId !== threadId)) return;
  useUploadThreadStore.setState((state) => {
    return {
      uploadThread: {
        ...state.uploadThread,
        [threadId]: {
          ...state.uploadThread[threadId],
          ...info,
        },
      },
    };
  });
}

export function removeThread(threadId: string) {
  useUploadThreadStore.setState((state) => {
    const newThread = { ...state.uploadThread };
    delete newThread[threadId];
    return { uploadThread: newThread };
  });
}

export function setCancelTaskId(taskId?: string) {
  useUploadThreadStore.setState((state) => {
    return {
      cancelTaskId: taskId,
    };
  });
}
